<script>

    import Image from "./Image.svelte";
    import {optionsStore} from "../core/app-store.js";
    import {createEventDispatcher} from "svelte";
    import NutritionalBar from "./NutritionalBar.svelte";
    import Price from "./Price.svelte";
    const dispatch = createEventDispatcher();

    export let record;
    export let publishConfig;
    export let tenantKey;
    export let cardHeight;
    export let reverse;

    let nutritionalOpen = false;

    const toggleDetailsScreen = (record) => {
        dispatch('toggleDetailsScreen', record);
    }

</script>
<style>

    .card {
        flex: 1 1 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        gap: 6px;
    }
    .card .media-block {
        position: relative;
        height: 200px;
        border: 1px solid var(--accent-color);
    }
    .card .media-block .label {
        position: absolute;
        top: 10px;
        left: 10px;
        text-transform: uppercase;
        font-family: PT Mono, sans-serif;
        font-size: 12px;
        letter-spacing: 1.2px;
        border-radius: 2rem;
        opacity: .9;
        line-height: 1;
        background: var(--accent-color);
        color: var(--bg-color);
        overflow: hidden;
        padding: 5px 8px 4px 8px;
    }
    .description {
        color: var(--secondary-font-color);
        line-height: 120%;
        font-family: Roboto, sans-serif;
        font-size: 16px;
    }

    @media (min-width: 768px) {
        .card {
            min-height: 274px;
            border: 1px solid var(--accent-color);

            display: flex;
            flex-direction: row;
            gap: 36px;
            padding: 16px;
        }
        .card--reverse {
            flex-direction: row-reverse;
        }
        .card .media-block,
        .card .info-block {
            flex: 1 1 100%;
            width: 100%;
            height: 100%;
        }
        .card .media-block {
            border: none;
            aspect-ratio: 16 / 9;
            max-width: 50%;
        }
        .card .info-block {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 12px;
            padding: 12px;
        }
        .card .info-block .record-name {
            color: var(--accent-color);
            font-size: 48px;
            font-weight: 600;
            text-align: center;
        }
        .card .info-block .record-name--long {
            font-size: 24px;
        }
        .card .info-block .description {
            text-transform: uppercase;
            color: var(--main-font-color);
            line-height: 150%;
            font-size: 16px;
            font-family: Roboto, sans-serif;
            text-align: center;
            width: 80%;
        }
        .card .info-block .description--long {
            font-size: 14px;
            width: 100%;
        }

        .card.hide-on-mobile .info-block span.price {
            font-size: 24px !important;
        }
    }
</style>

<!-- DESKTOP -->
<div class="card desktop-col-full hide-on-mobile user-select-none" class:card--reverse={reverse} on:click={() => toggleDetailsScreen(record)}>

    <!-- MEDIA -->
    <div class="media-block">
        {#if (record?.media?.length > 0)}
            <Image src={record?.media[0]?.name}
                   tenantKey={record?.media[0]?.ref || tenantKey}
                   hasVideo={ (record.media || []).find(x => x.type === 'video') !== undefined }
                   animation="{ record.promoted?.enabled === true ? 'scale' : 'none' }"
                   alt={record?.name || ''}>
            </Image>
        {:else }
            <Image alt={record?.name || ''}></Image>
        {/if}

        {#if (record.label !== null && record.label !== undefined)}
            <span class="label">
                { record.label }
            </span>
        {/if}
    </div>

    <div class="info-block pointer">

        <h4 class="record-name"
            class:record-name--long={record.name?.length > 20}
            on:click={() => {nutritionalOpen = !nutritionalOpen;}}>
            {record.name || ''}
        </h4>

        {#if (record.description) }
            <div class="description"
                 class:description--long={record.description?.length > 60}>
                { record.description }
            </div>
        {/if}

        <div>
            <Price record={record}
                   priceItem={record.prices[0]}
                   publishConfig={publishConfig}
                   size="lg"
                   on:add={(e) => dispatch('addToCart', e.detail)}
                   on:remove={(e) => dispatch('removeFromCart', e.detail)}>
            </Price>
        </div>
    </div>
</div>

<!-- MOBILE -->
<div class="card hide-on-desktop user-select-none pointer" on:click={() => toggleDetailsScreen(record)}>

    <!-- MEDIA -->
    <div class="media-block">
        {#if (record?.media?.length > 0)}
            <Image src={record?.media[0]?.name}
                   tenantKey={record?.media[0]?.ref || tenantKey}
                   hasVideo={ (record.media || []).find(x => x.type === 'video') !== undefined }
                   animation="{ record.promoted?.enabled === true ? 'scale' : 'none' }"
                   imgHeight="{cardHeight}"
                   alt={record?.name || ''}>
            </Image>
        {:else }
            <Image imgHeight="{cardHeight}" alt={record?.name || ''}></Image>
        {/if}

        {#if (record.label !== null && record.label !== undefined)}
            <span class="label">
                { record.label }
            </span>
        {/if}
    </div>

    <!-- INFO -->
    <div class="flex-between ai-center gap-05">
        <h4 class="record-name" on:click={() => {nutritionalOpen = !nutritionalOpen;}}>
            {record.name || ''}
        </h4>
        <div>
            <Price record={record}
                   priceItem={record.prices[0]}
                   publishConfig={publishConfig}
                   on:add={(e) => dispatch('addToCart', e.detail)}
                   on:remove={(e) => dispatch('removeFromCart', e.detail)}
            >
            </Price>
        </div>
    </div>

    {#if (record.description) }
        <div class="description">
            { record.description }
        </div>
    {/if}

    {#if (record._found_desc && record.promoted?.enabled === true)}
        <div class="found_description fs-90 lh-110 flex-fill">
            {@html record._found_desc }
        </div>
    {/if}

    <NutritionalBar record={record}
                    open={nutritionalOpen}>
    </NutritionalBar>

</div>
